import { Gallery, Profile } from "@simplebooth/webkit";
import { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { Stack } from "@mui/material";
import BrandedBackground from "../BrandedBackground/BrandedBackground";
import BrandedHeader from "../BrandedHeader/BrandedHeader";
import Container, { ContainerSize } from "../Container/Container";
import FinePrintDisplayer from "../FinePrintDisplayer/FinePrintDisplayer";
import ProfileTopBar from "../GalleryPage/ProfileLinks/ProfileTopBar/ProfileTopBar";
import Avatar from "../GalleryPage/ProfileLinks/Avatar/Avatar";
import stylesheet from "./GalleryBrandedPage.module.scss"

interface GalleryBrandedPageProps {
  gallery: Gallery
  profile?: Profile
  controls?: ReactNode
  containerClassName?: string
  containerSize: ContainerSize
  children: ReactNode
}

export default function GalleryBrandedPage({ gallery, profile, controls, containerClassName, containerSize, children }: GalleryBrandedPageProps) {
  const showDefaultLogo = gallery.design.showSimpleBoothLogo && gallery.hasDefaultBackgroundColor()
  const isProfilePublic = profile && (profile.public === undefined || profile.public)

  return (
    <>
      <Helmet>
        <title>{gallery.title}</title>
      </Helmet>
      <BrandedBackground
        fixed
        firstColor={gallery.design.backgroundColor}
        secondColor={gallery.design.backgroundColor}
        allowDefaultBackgroundConfetti={!gallery.hasDesignCustomizations()}
      >
        <Container
          className={`${containerClassName ?? ""} ${stylesheet.bottomPadding}`}
          size={containerSize}
        >
          {isProfilePublic && <ProfileTopBar profile={profile}/>}
          {(controls || isProfilePublic) && (
            <Stack direction={isProfilePublic ? "row" : "row-reverse"} justifyContent="space-between" alignItems="center" sx={{mt: 1.5}}>
              {isProfilePublic && <Avatar profile={profile}/>}
              {controls}
            </Stack>
          )}
          <BrandedHeader
            showDefaultLogo={showDefaultLogo}
            imageAsset={gallery.design.topImageAsset}
            imageHref={gallery.design.topUrl}
            heading={gallery.title}
            description={gallery.description}
            textColor={gallery.design.textColor}
          />
          {children}
        </Container>
        <FinePrintDisplayer gallery={gallery} />
      </BrandedBackground>
    </>
  )
}
